/**
 * Akro cart drawer upsell — Gift Wrapping cross-sell.
 *
 * Pattern mirrors assets/akro-wishlist-cart.js:
 *   fetch /cart/add.js  ->  document.dispatchEvent('theme:update:cart')
 *
 * Loaded once in layout/theme.liquid and uses document-level event
 * delegation, so the listener stays valid even when cart-footer is
 * morphed in via Baseline's section-refresh.
 *
 * Also injects a tiny stylesheet for `.akro-upsell__btn` because the
 * drawer has a high-specificity custom rule forcing `color: white` on
 * every button/p/span inside `#right-drawer-slot`. The upsell button
 * needs black text on white bg to stand out against the translucent
 * gray drawer, so we override with a more-specific selector.
 */
(function () {
  if (window.__akroUpsellWired) return;
  window.__akroUpsellWired = true;

  // --- inject button styles (once) ----------------------------------
  var style = document.createElement('style');
  style.setAttribute('data-akro-upsell-style', '');
  style.textContent = [
    '#right-drawer-slot .akro-upsell__btn,',
    '.akro-upsell__btn {',
    '  background-color: #fff;',
    '  color: #000;',
    '  border: 1px solid #000;',
    '  padding: 8px 16px;',
    '  font-size: 0.8125rem;',
    '  line-height: 1;',
    '  letter-spacing: 0.02em;',
    '  white-space: nowrap;',
    '  transition: background-color .15s ease, color .15s ease, border-color .15s ease;',
    '}',
    '#right-drawer-slot .akro-upsell__btn:hover,',
    '#right-drawer-slot .akro-upsell__btn:focus-visible,',
    '.akro-upsell__btn:hover,',
    '.akro-upsell__btn:focus-visible {',
    '  background-color: #000;',
    '  color: #fff;',
    '}',
    '#right-drawer-slot .akro-upsell__btn[disabled],',
    '#right-drawer-slot .akro-upsell__btn[aria-busy="true"],',
    '.akro-upsell__btn[disabled],',
    '.akro-upsell__btn[aria-busy="true"] {',
    '  opacity: .6;',
    '  cursor: progress;',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  // --- click delegation ---------------------------------------------
  // NOTE: capture phase is mandatory here. The cart drawer slot
  // (snippets/right-drawer.liquid) has Alpine's `@click.stop`, which
  // calls stopPropagation() on every click inside the drawer. A bubble-
  // phase listener on document would never fire. Capture phase runs
  // before .stop kicks in.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest
      ? e.target.closest('[data-akro-upsell-add]')
      : null;
    if (!btn || btn.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-akro-upsell-variant');
    if (!variantId) return;

    var card = btn.closest('[data-akro-upsell]');
    var errorEl = card ? card.querySelector('[data-akro-upsell-error]') : null;

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (errorEl) {
      errorEl.classList.add('hidden');
      errorEl.textContent = '';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }]
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) {
            var msg = (data && (data.description || data.message)) || 'Add failed';
            throw new Error(msg);
          }
          // Baseline cart refresh: theme-events.js re-fetches the cart
          // sections (cart-items, cart-footer, cart-item-count, cart-live-region)
          // and dispatches baseline:cart:update so all listeners stay in sync.
          // The snippet lives inside cart-footer so it disappears on its
          // own once the variant is in the cart.
          document.dispatchEvent(new CustomEvent('theme:update:cart'));
        });
      })
      .catch(function (err) {
        if (errorEl) {
          errorEl.textContent =
            (err && err.message) ? err.message : 'Erreur lors de l\'ajout.';
          errorEl.classList.remove('hidden');
        }
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
  }, true);
})();
